import { forwardRef } from 'react';
import { NavLink } from 'react-router-dom';
import { PropTypes } from 'prop-types';

export const AnchorLink = forwardRef(({ href, ...props }, ref) => {
    return <NavLink ref={ref} to={href} {...props} />;
});

AnchorLink.propTypes = {
    href: PropTypes.string,
};

AnchorLink.displayName = 'AnchorLink';
